"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscriptionProfileQuery = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _api = require("../api");
var _swrConfig = require("../constants/swrConfig");
var _contexts = require("../contexts");
var _models = require("../models");
/* eslint-disable complexity -- gql */

const useSubscriptionProfileQuery = () => {
  const {
    headers: rawHeaders
  } = (0, _presentationHttp.useHeaders)();
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    customerId,
    isSubscriptionsPage
  } = (0, _contexts.useCheckoutDeliveryContext)();
  const headers = {
    ...rawHeaders,
    [_fetching.CUSTOMER_CONTEXT]: String(customerId)
  };
  const response = (0, _fetching.useSWR)(() => isSubscriptionsPage ? {
    graphQlNetUrl,
    headers
  } : null, _api.getSubscriptionProfile, {
    ..._swrConfig.errorHandlingSwrOptions
  });
  const address = response.data?.address;
  const deliveryChannel = response.data?.deliveryChannel;
  const isHomeDelivery = deliveryChannel?.deliveryMethod === _models.AddressItemDeliveryMethod.Home;
  const deliveryItem = Number(response.data?.addressId) ? {
    addressId: Number(response.data?.addressId),
    area: (isHomeDelivery ? address?.area : deliveryChannel?.address?.area) ?? undefined,
    city: (isHomeDelivery ? address?.city : deliveryChannel?.address?.city) ?? '',
    country: (isHomeDelivery ? address?.country : deliveryChannel?.address?.country) ?? undefined,
    deliveryChannelId: Number(deliveryChannel?.deliveryChannelId),
    deliveryFee: 0,
    deliveryMethod: deliveryChannel?.deliveryMethod ?? _models.AddressItemDeliveryMethod.Home,
    description: deliveryChannel?.description ?? '',
    district: (isHomeDelivery ? address?.district : deliveryChannel?.address?.district) ?? undefined,
    estimatedDelivery: '',
    hintMessages: [],
    deliveryComment: '',
    isAddressDeletable: false,
    isAddressEditable: true,
    isAllowed: true,
    isCommentEnabled: false,
    isDefault: false,
    isEndConsumerAddress: false,
    isLastUsed: false,
    isPrimaryAddress: false,
    isShippingJoker: false,
    locality: (isHomeDelivery ? address?.locality : deliveryChannel?.address?.locality) ?? undefined,
    name: (isHomeDelivery ? `${address?.firstName} ${address?.lastName}` : deliveryChannel?.description) ?? '',
    originalDeliveryFee: 0,
    outOfStockQuantity: 0,
    outOfStockProducts: [],
    ownerName: '',
    province: (isHomeDelivery ? address?.province : deliveryChannel?.address?.province) ?? undefined,
    region: (isHomeDelivery ? address?.region : deliveryChannel?.address?.region) ?? undefined,
    streetAddress: (isHomeDelivery ? address?.streetAddress : deliveryChannel?.address?.streetAddress) ?? '',
    telephoneNumber: response.data?.deliveryChannel?.telephoneNumber ?? '',
    workingHours: response.data?.deliveryChannel?.workingHours ?? '',
    zipCode: (isHomeDelivery ? address?.zipcode : deliveryChannel?.address?.zipcode) ?? ''
  } : undefined;
  return {
    subscriptionProfileError: response.error,
    subscriptionProfileItem: deliveryItem,
    isSubscriptionProfileLoading: response.isValidating,
    mutateSubscriptionProfile: response.mutate
  };
};
exports.useSubscriptionProfileQuery = useSubscriptionProfileQuery;